import React from "react";
import { Box, Typography } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import {
  BgBox,
  Table,
  Td,
  Th,
  Titles,
  Tr,
} from "my-tax/styles/my-tax-credit-information.style";
import { OcFooter } from "oc/components";
import { ocLightTheme } from "oc/themes/oc-light-theme";

export const MyTaxUnderTwentyFiveTaxCreditInformationPage = () => {
  return (
    //Ha eltávolítjuk a ThemeProvider-ert, akkor nem jeleníti meg a stílusokat. Feltételezhetően azért, mert új tab-on nyílik meg.
    //If we remove the ThemeProvider, it will not display the styles. Probably because it opens in a new tab.
    <ThemeProvider theme={ocLightTheme}>
      <Box>
        <Box padding="16px" style={{ backgroundColor: "#F1F3F4" }}>
          <Box>
            <Typography
              variant="h4"
              style={{
                fontSize: "34px",
                fontWeight: "400",
                color: "#5E6366",
                display: "flex",
                justifyContent: "center",
              }}
            >
              Tájékoztató
            </Typography>
            <Box height="32px" />
            <Typography
              variant="h5"
              style={{
                fontSize: "24px",
                fontWeight: "400",
                color: "#212121",
                display: "flex",
                justifyContent: "center",
              }}
            >
              A 25 év alatti fiatalok kedvezményének részben vagy egészben
              történő mellőzéséről szóló nyilatkozatról{" "}
            </Typography>
            <Box height="32px" />
            <BgBox>
              <Typography variant="h5" component={Titles}>
                <b>Tudnivalók a nyilatkozathoz</b>
              </Typography>
              <Box height="32px" />
              <Typography variant="body1">
                Ha Ön jogosult a 25 év alatti fiatalok kedvezményére,{" "}
                <b>
                  akkor azt a munkáltatója, kifizetője mindaddig automatikusan
                  figyelembe veszi, amíg nem nyilatkozik annak részben vagy
                  egészben történő mellőzéséről.
                </b>{" "}
                Nyilatkozni akkor kell, ha döntése szerint nem kéri a kedvezmény
                figyelembevételét, vagy csak a kedvezmény egy részének a
                figyelembevételét kéri az adóelőleg megállapításakor.
              </Typography>
              <Box height="25px" />
              <Typography variant="h6">
                <b>Kinek kell átadni ezt a nyilatkozatot?</b>
              </Typography>
              <Box height="25px" />
              <Typography variant="body1">
                <b>
                  Ahhoz, hogy a kedvezmény érvényesítését munkáltatója,
                  kifizetője részben vagy egészben mellőzze, ezt a nyilatkozatot
                  két példányban kell átadni neki.
                </b>{" "}
                A nyilatkozat egyik példányát a munkáltatónak (kifizetőnek),
                másik példányát pedig Önnek kell az adóbevallás elkészítéséhez
                szükséges bizonylatokkal együtt az elévülési időn belül, azaz a
                bevallás benyújtásának évét követő 5. év végéig megőriznie.
              </Typography>
              <Box height="25px" />
              <Typography variant="body1">
                <i>
                  Ha Ön nem tesz nyilatkozatot az érvényesítés teljes vagy
                  részleges mellőzéséről, és ezért az adóbevallásában 10 ezer
                  forintot meghaladó befizetési kötelezettsége keletkezik, akkor
                  ennek 12 százalékát különbözeti-bírságként kell megfizetnie az
                  adóhátralékával együtt.
                </i>
              </Typography>
              <Box height="25px" />
              <Typography variant="h6">
                <b>Kinek jár a kedvezmény?</b>
              </Typography>
              <Box height="25px" />
              <Typography variant="body1">
                A kedvezmény igénybevételére a 25. életévét be nem töltött fiatal jogosult. <br />
                2026-tól az a 25 év alatti édesanya, aki jogosult a 30 év alatti anyák kedvezményére, a 30 év alatti
                anyák kedvezményét veheti igénybe.
              </Typography>
              <Box height="25px" />
              <Typography variant="h6">
                <b>Mennyi kedvezmény jár?</b>
              </Typography>
              <Box height="25px" />
              <Typography variant="body1">
                A 25 év alatti fiatalok kedvezménye a 25 életévét be nem töltött
                fiatal összevont adóalapjába tartozó egyes jövedelmeit
                csökkenti. 2026-ban a kedvezmény összege jogosultsági
                hónaponként 715 765 forint, ami 107 365 forint adómegtakarítást
                jelent.
              </Typography>
              <Box height="25px" />
              <Typography variant="h6">
                <b>Milyen jövedelmet érint?</b>
              </Typography>
              <Box height="25px" />
              <Typography variant="body1">
                A kedvezménnyel csökkenthető például a bérjövedelem, a megbízási
                díj, az őstermelői jövedelem, az egyéni vállalkozó átalányban
                megállapított jövedelme, vagy vállalkozói kivétje.
              </Typography>
              <Box height="25px" />
              <Typography variant="h6">
                <b>Adatváltozáskor mit kell tenni?</b>
              </Typography>
              <Box height="25px" />
              <Typography variant="body1">
                Ha a nyilatkozatban közölt adatok változnak,{" "}
                <b>Ön köteles haladéktalanul új nyilatkozatot tenni,</b> vagy a
                korábbi nyilatkozatot visszavonni.
              </Typography>
              <Box height="25px" />
              <Typography variant="h6">
                <b>
                  Külföldi magánszemély milyen feltételek mellett érvényesítheti
                  a kedvezményt?
                </b>
              </Typography>
              <Box height="25px" />
              <Typography variant="body1">
                Ha Ön külföldi magánszemély, akkor 2025-től a 25 év alatti
                fiatalok kedvezményt akkor veheti igénybe, ha EGT-állam vagy
                Magyarországgal határos, nem EGT-állam (Ukrajna, Szerbia)
                állampolgára és az alábbi feltételeknek megfelel.
              </Typography>
              <Typography variant="body1">
                Önnek csak akkor jár a 25 év alatti fiatalok kedvezménye, ha
                azonos vagy hasonló <b>kedvezményt</b> ugyanarra az időszakra{" "}
                <b>másik államban nem vett és nem is vesz igénybe.</b>
              </Typography>
              <Box height="25px" />
              <Typography variant="body1">
                A külföldi adóügyi illetőségű magánszemély a kedvezményt
                Magyarországon csak akkor érvényesítheti, ha az adóévben
                megszerzett összes jövedelmének – ideértve a Magyarországon nem
                adóztatható jövedelmet is –{" "}
                <b>75 százaléka Magyarországon adózik.</b>
              </Typography>
              <Box height="25px" />
              <Typography variant="body1">
                <b>
                  Ha Ön külföldi adóügyi illetőségű, a „Kiegészítő nyilatkozat a
                  külföldi adóügyi illetőségű magánszemélyek
                  adóalap-kedvezményének érvényesítéséhez” nyilatkozatát ki kell
                  töltenie és a munkáltató, kifizető részére átadnia a
                  kedvezményének igénybevételéhez. Adóazonosító jelét ebben az
                  esetben is meg kell adni.
                </b>
              </Typography>
              <Box height="25px" />
              <Typography variant="body1">
                <b>
                  Ha Ön hontalan vagy rendelkezik huzamos tartózkodási engedéllyel -
                  tekintettel arra, hogy ilyen esetben az Szja tv. 3. § 2. pont c) alpontja értelmében
                  belföldi illetőségűnek minősül Magyarországon - szintén érvényesítheti a 25 év
                  alatti fiatalok kedvezményét.
                </b>
              </Typography>
              <Box height="25px" />
            </BgBox>
            <Box height="16px" />
            <BgBox>
              <Typography variant="h5" component={Titles}>
                <b style={{ textDecoration: "underline" }}>Példa:</b>
              </Typography>
              <Box height="25px" />
              <Typography variant="body1">
                A 25 év alatti fiatalnak két munkáltatója van. Az egyik helyen
                havi 500 ezer forint a jövedelme, a másik munkaviszonyában havi
                300 ezer forintot keres. Jövedelmeinek összege külön-külön nem
                haladja a meg az adómentes összeghatárt, de együtt igen (800 000
                {" > "}
                715 765). A fiatalnak adóelőleg-nyilatkozatot kell adnia mindkét
                munkáltatójának, hogy az igénybe vett kedvezmény együttesen ne
                haladja meg a kedvezmény maximum összegét, de eldöntheti, hogy
                melyik jövedelméből mennyi kedvezményt szeretne igénybe
                venni.{" "}
              </Typography>
              <Box height="25px" />
              <Typography variant="body1">
                Például így is kérheti a kedvezmény figyelembevételét:{" "}
              </Typography>
              <Box height="25px" />
              <Box
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Table>
                  <Tr>
                    <Th></Th>
                    <Th>I. eset</Th>
                    <Th>II. eset</Th>
                    <Th>III. eset</Th>
                  </Tr>
                  <Tr>
                    <Td>első munkáltató</Td>
                    <Td>500 000</Td>
                    <Td>415 765</Td>
                    <Td>415 000</Td>
                  </Tr>
                  <Tr>
                    <Td>második munkáltató</Td>
                    <Td>215 765</Td>
                    <Td>300 000</Td>
                    <Td>300 765</Td>
                  </Tr>
                </Table>
              </Box>
              <Box height="25px" />
              <Typography variant="body1">
                Azért kell mindkét munkáltatónak nyilatkozatot adni, mert ha
                munkabérén felül többletjövedelmet, például jutalmat kap, akkor
                a nyilatkozat nélkül a munkáltató arra is érvényesíti a
                kedvezményt.
              </Typography>
              <Box height="25px" />
              <Typography variant="body1">
                Például a II. esetben, ha a második munkáltató 100 ezer forint
                jutalmat fizet a fiatalnak, és nem kapott arról nyilatkozatot,
                hogy 300 ezer forint felett ne vegye a figyelembe a kedvezményt,
                akkor azt a jutalomra is figyelembe veszi, ami jogosulatlan
                igénybevételt jelent.
              </Typography>
              <Box height="25px" />
              <Typography variant="body1">
                Ha a fiatal csak az egyik munkáltatójának nyilatkozik arról,
                hogy a <b>kedvezmény mellőzését kéri,</b> akkor a másik
                munkáltatónak már nem kell nyilatkozatot adnia, hiszen az csak a
                kedvezmény mértékéig érvényesíti azt.
              </Typography>
              <Box height="25px" />
              <Typography variant="body1">
                Ha a kedvezményt az adóelőleg megállapításakor nem veszik
                figyelembe, akkor azt a bevallásában utólag érvényesítheti, ha
                van olyan jövedelme, ami a kedvezmény alapját képezi.
              </Typography>
              <Box height="25px" />
              <Typography variant="body1">
                A kedvezményről bővebb tájékoztatást olvashat a NAV honlapján
                (www.nav.gov.hu) az „Szja adóalap-kedvezmények” című 73. számú
                információs füzetben.{" "}
              </Typography>
              <Box height="25px" />
            </BgBox>
            <Box height="25px" />
          </Box>
        </Box>
        <OcFooter />
      </Box>
    </ThemeProvider>
  );
};

export default MyTaxUnderTwentyFiveTaxCreditInformationPage;
